const checkForDisabledBtns = () => {
    const starContainers = document.querySelectorAll('.kksr-disabled');
    [...starContainers].forEach( starContainer => {
        const videoStars = starContainer.closest('.video__stars');
        const voteBtn = videoStars.querySelector('.vote-btn');
        const itemJson = JSON.parse(starContainer.dataset.payload);

        const { legend } = itemJson;

        videoStars.classList.add('disabled');
        if ( voteBtn ) {
            voteBtn.disabled = true;
            voteBtn.innerText = legend;
        }
        
    })
}

const vote = () => {
    const voteStarBtns = document.querySelectorAll('.kksr-star');

    [...voteStarBtns].forEach( voteBtn => {
        voteBtn.addEventListener('click', (e) => {
            e.preventDefault();

            const wrapper = e.target.closest('.video__actions');
            const btnContainer = e.target.closest('.video__stars');
            const btn = btnContainer.querySelector('.vote-btn');
            const starsBox = e.target.closest('.kk-star-ratings');
            const countBox = wrapper.querySelector('.video__votes-count span');
            const itemJson = JSON.parse(starsBox.dataset.payload);
            const { legend } = itemJson;

            setTimeout( () => {
                btnContainer.classList.add('disabled');
                btn.disabled = true;
                btn.innerText = `${legend}`;
                const num = parseInt(countBox.innerText) + 1;    
                countBox.innerText = num;
            }, 500);
        })
    });

}

export { vote, checkForDisabledBtns };